export { default } from './ProductSuggestion'